import service from '@/service'
import urlManager from '@/urlManager'

/**
 * This is the store module for starred items
 */
export default {
  namespaced: true,
  state: () => ({
    starred: null
  }),
  mutations: {
    SET_STARRED(state, starred) {
      state.starred = starred
    }
  },
  getters: {
    starred: state => state.starred
  },
  actions: {
    async getStarred({ commit }, orgId) {
      const response = await service.client.get(urlManager.starredList(orgId))
      commit('SET_STARRED', response.data)
      return response.data
    },
    star(_, { contextType, contextId, orgId }) {
      return service.client.post(urlManager.starredList(orgId), {
        contextType,
        contextId
      })
    },
    unstar(_, { starredId, orgId }) {
      return service.client.delete(urlManager.starredDetails(orgId, starredId))
    },
    cleanStarred({ commit }) {
      commit('SET_STARRED', null)
    }
  }
}
